const $ = jQuery.noConflict();

// Add external link icon to header & footer links on hover

$('.external-link--blue').append($('<span class="opacityZero"><img src="/img/external-link--defaultblue.svg" alt="external-link-icon"></span>'));

$('.external-link--blue').hover(
  function () {
    $(this).children('span').removeClass('opacityZero');
  }, function () {
    $(this).children('span').addClass('opacityZero');
  }
);

$('.external-link--white').append($('<span class="opacityZero"><img src="/img/external-link--white.svg" alt="external-link-icon"></span>'));

$('.external-link--white').hover(
  function () {
    $(this).children('span').removeClass('opacityZero');
  }, function () {
    $(this).children('span').addClass('opacityZero');
  }
);


$(document).ready(function () {

  // Attaches the fancybox toolbar to the slide so the close button is always just above it for each instance
  const heroCta = document.querySelectorAll('a.fancybox');
  heroCta.forEach(function (fancyClick){
    fancyClick.addEventListener('click', function () {
      $('.fancybox-toolbar').prependTo('.fancybox-slide');
    });
  });

  //format the ribbon text
  $('main .ribbon--yellow').each(function (index, value){

    let text = $(value).html();

    let tmp = $.trim(text).split(' ');

    let ret = '';

    for (let i = 0; i < tmp.length; i++) {

      ret += '<span>' + tmp[i] + '</span>';
    }

    $(value).html(ret);
  });
});

window.lazyLoadOptions = {
  threshold: 200
};
